export default __webpack_public_path__ + "static/media/marker.e9bd65a4.svg";